import { useMemo } from 'react';

import { TabTableContainer } from 'components/layout/AppLayout/AppLayout.styled';
import DynamicList from 'components/list/DynamicList';
import { FilterType, ListComponents } from 'components/list/DynamicListFilterUtils';

import { ENUMS, MARKETING } from 'services/consts';

import { DYNAMICLISTS } from 'utils/constants';

const PromoTransactionsList = () => {
	const defaultSort = useMemo(() => [{ id: 'transactionDate', desc: true }], []);

	const columns = useMemo(
		() => [
			{
				Header: 'promoCode',
				accessor: 'promoCode',
				filterType: FilterType.string,
				showOnMobile: true
			},
			{
				Header: 'promoCodeType',
				accessor: 'promoCodeType',
				filterType: FilterType.enumMulti,
				enumName: ENUMS.PROMO_CODE_TYPE
			},
			{
				Header: 'transactionDate',
				accessor: 'transactionDate',
				filterType: FilterType.date,
				renderCell: ListComponents.DATETIME
			},
			{
				Header: 'clientName',
				accessor: 'clientName',
				filterType: FilterType.string
			},
			{
				Header: 'clientType',
				accessor: 'clientType',
				filterType: FilterType.string
			},
			{
				Header: 'freeCreditGot',
				accessor: 'freeCreditGot',
				filterType: FilterType.float
			},
			{
				Header: 'paidPrice',
				accessor: 'paidPrice',
				filterType: FilterType.float
			},
			{
				Header: 'givenAmount',
				accessor: 'givenAmount',
				filterType: FilterType.float
			},
			{
				Header: 'remainingAmount',
				accessor: 'remainingAmount',
				filterType: FilterType.float
			},
			{
				Header: 'currency',
				accessor: 'currency',
				filterType: FilterType.string
			},
			{
				Header: 'expiryDate',
				accessor: 'expiryDate',
				filterType: FilterType.date,
				renderCell: ListComponents.DATETIME
			},
			{
				Header: 'country',
				accessor: 'country',
				filterType: FilterType.enumMulti,
				enumName: ENUMS.COUNTRIES,
				filterPrefix: 'country.',
				renderCell: ListComponents.COUNTRY
			}
		],
		[]
	);

	return (
		<TabTableContainer>
			<DynamicList
				id={DYNAMICLISTS.PROMO_TRANSACTIONS}
				columns={columns}
				infiniteScroll
				fetchUrl={MARKETING.GET_PROMO_TRANSACTIONS_LIST}
				exportName="promoTransactions"
				defaultSort={defaultSort}
			/>
		</TabTableContainer>
	);
};

export default PromoTransactionsList;
